import { Box } from '@mui/material'
import { useAlert } from 'context/AlertContext'
import React, { useEffect, useState } from 'react'
import { type ApiFile } from 'types/Application'
import { downloadFile } from './utils/download-file'

export const Images = ({ files }: { files: ApiFile[] }): JSX.Element => {
  const { changeMessage } = useAlert()
  const [selectedFile, setSelectedFile] = useState(files[0] ?? null)
  const [selectedUrl, setSelectedUrl] = useState<string>('')
  const [pos, setPos] = useState<{ x: number | null; y: number | null }>({ x: null, y: null })

  useEffect(() => {
    if (!selectedFile) {
      return
    }

    downloadFile(selectedFile, message => changeMessage(message, 'error')).then(result => {
      if (result) {
        setSelectedUrl(result)
      }
    })
  }, [changeMessage, selectedFile])

  const handleMouseMove: React.MouseEventHandler<HTMLDivElement> = e => {
    setPos({ x: e.nativeEvent.offsetX || 0, y: e.nativeEvent.offsetY || 0 })
  }

  const handleResetPos = (): void => {
    setPos({ x: null, y: null })
  }

  return (
    <>
      <Box
        sx={{ width: 500, overflow: 'clip', p: 0, position: 'relative', borderRadius: '8px' }}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleResetPos}
      >
        <a
          href={`${selectedUrl}`}
          download={`${selectedFile.file.originalName}${selectedFile.file.extension ? `.${selectedFile.file.extension}` : ''}`}
          // href={`${selectedFile.file.originalName}${selectedFile.file.extension ? `.${selectedFile.file.extension}` : ''}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            style={{
              objectFit: 'contain',
              objectPosition: 'center',
              transform: pos.x !== null && pos.y !== null ? 'scale(1.5)' : undefined,
              transformOrigin: pos.x !== null && pos.y !== null ? `${pos.x}px ${pos.y}px` : undefined,
            }}
            src={selectedUrl}
            alt=""
            height={500}
            width={500}
          />
        </a>
      </Box>
      <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap' }}>
        {files.map(apiFile => (
          <SingleImage
            key={apiFile.id}
            onClick={() => {
              setSelectedFile(apiFile)
            }}
            apiFile={apiFile}
          />
        ))}
      </Box>
    </>
  )
}

const SingleImage = ({ apiFile, onClick }: { apiFile: ApiFile; onClick: () => void }) => {
  const { changeMessage } = useAlert()
  const [fileUrl, setFileUrl] = useState('')

  useEffect(() => {
    if (!apiFile) {
      return
    }

    downloadFile(apiFile, message => changeMessage(message, 'error')).then(result => {
      if (result) {
        setFileUrl(result)
      }
    })
  }, [changeMessage, apiFile])

  return (
    <img
      key={apiFile.id}
      onClick={onClick}
      src={fileUrl}
      alt=""
      height={100}
      width={100}
      style={{ objectFit: 'cover', borderRadius: '8px' }}
    />
  )
}
